<template>
	<div class="card-v2 card-upcoming-jobs">
		<header class="margin flex-split fle">
			<h2 class="m0">My Upcoming Jobs</h2>
			<div class="show-md flex fs-12">
				<SyncCalendarButton class="button-inline btn btn-link mr-24" icon="arrows-clockwise">
					Sync Calendar
				</SyncCalendarButton>
				<router-link :to="{ name: $routes.Jobs.name }">View All Jobs</router-link>
			</div>
		</header>

		<div v-if="loading">
			<div v-for="index in 3" :key="index" class="pt-16 pb-16">
				<div class="skeleton pt-16 mb-8" style="width:30%"></div>
				<div class="skeleton pt-16"></div>
			</div>
		</div>
		<div v-else-if="items.length" class="grid gap-16">
			<div v-for="job in items" :key="job.id" class="item border pt-16 pb-16 pl-20 pr-20 lg-pl-24 lg-pr-24 flex-top" @click="toJob(job)">
				<ProfileAvatar :src="job.creator.profile.studioLogo" :profile="job.creator.profile" size="50" class="mr-16 lg-mr-20 no-shrink" />
				<div class="grow">
					<div class="flex-split flex-top mb-8">
						<div class="pr-12">
							<div class="fs-12 fw-500 color-violet flex mb-4 gap-8">
								<div v-if="job.event.type && job.event.type.name" class="badge badge-gray">
									{{ job.event.type.name }}
								</div>
								<div v-if="job.creator.id == $activeUser.id" class="badge badge-green">Job Created</div>
								<span class="studio-name" @click="toStudio(job, $event)">Studio: {{ job.creator.profile.studioName ? job.creator.profile.studioName : job.creator.name }}</span>
							</div>
							<div class="fs-16 lg-fs-18 fw-700 color-violet job-name">
								{{ job.event.name }}
							</div>
						</div>
						<button class="unread-wrap btn btn-util square-32" @click="toJobChat(job, $event)">
							<icon-chat />
							<div v-if="job._chatInfo.unreadMessagesCount" class="unread-messages-count">{{ job._chatInfo.unreadMessagesCount }}</div>
						</button>
					</div>
					<div class="job-details">
						<div class="flex fs-14">
							<div>
								<icon-circle-dollar-sign class="block" />
							</div>
							<div class="ml-8"> {{ getRoleName(job.positionId) }}<template v-if="job.creator.id == $activeUser.id">: <span class="shooter-name fw-500" @click="toShooter(job, $event)">{{ job.contract.employee.name }}</span></template> - ${{ job.contract.ratePerHour }} per hour</div>
							</div>
						<div class="flex fs-14">
							<div>
								<icon-time class="block" />
							</div>
							<div class="ml-8">{{ job.event.formattedEventDate.split(',')[0].substring(0,3) }}, {{ job.event.formattedEventDate.split(',')[1] }}</div>
						</div>
						<div class="flex fs-14">
							<div>
								<icon-location class="block" />
							</div>
							<div class="ml-8">{{ job.event.formattedLocation }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="hide-md flex fs-12">
				<SyncCalendarButton class="button-inline btn btn-link mr-24 ml-4" icon="arrows-clockwise">
					Sync Calendar
				</SyncCalendarButton>
				<router-link :to="{ name: $routes.Jobs.name }">View All Jobs</router-link>
			</div>
		</div>
		<div v-else class="null-message">
			<svg width="92" height="53" viewBox="0 0 92 53" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity=".3" x="1" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><rect opacity=".3" x="12.815" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><rect opacity=".3" x="24.631" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><rect opacity=".3" x="36.446" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><rect opacity=".3" x="48.262" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><rect opacity=".3" x="60.077" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><rect opacity=".3" x="71.893" width="10.186" height="2.849" rx="1.425" fill="#0EA8FE"/><circle cx="41.603" cy="23.507" r="4.274" fill="#D9F9F6"/><path d="M39.75 23.958 40.82 25l2.359-3" stroke="#009A8B" stroke-linecap="round" stroke-linejoin="round"/><circle cx="29.493" cy="47.097" r="4.274" fill="#D9F9F6"/><path d="m27.75 47.458 1.07 1.042 2.359-3" stroke="#009A8B" stroke-linecap="round" stroke-linejoin="round"/><circle cx="53.356" cy="23.507" r="4.274" fill="#D9F9F6"/><circle cx="41.603" cy="47.097" r="4.274" fill="#D9F9F6"/><path d="M51.75 23.958 52.82 25l2.359-3M39.75 47.458l1.07 1.042 2.359-3" stroke="#009A8B" stroke-linecap="round" stroke-linejoin="round"/><circle cx="65.11" cy="23.507" r="4.274" fill="#D9F9F6"/><circle cx="76.863" cy="23.507" r="4.274" fill="#D9F9F6"/><path d="M63.75 23.958 64.82 25l2.359-3" stroke="#009A8B" stroke-linecap="round" stroke-linejoin="round"/><path d="m75.082 24.088 1.134 1.2s.683-2.42 2.072-3.918" stroke="#009918" stroke-linecap="round" stroke-linejoin="round"/><path d="m4.368 36.834 3.355-3.355M4.368 33.48l3.355 3.355M27.875 24.725l3.355-3.355M27.874 21.37l3.356 3.355" stroke="#ED2744" stroke-linecap="round" stroke-linejoin="round"/><path opacity=".3" d="M12.041 5.699V52M81.85 41.315H1.355M81.85 29.206H1.355M81.85 17.096H1.355M23.794 5.699V52M35.548 5.699V52M47.301 5.699V52M59.055 5.699V52M70.808 5.699V52" stroke="#0EA8FE" stroke-linecap="round" stroke-linejoin="round"/><path d="M86.407 2.698s1.976-.998 3.868.3c1.893 1.3 1.72 3.534 1.72 3.534L90.328 8.87 84.74 5.034l1.666-2.336Z" fill="#ED2744"/><mask id="a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="84" y="2" width="8" height="7"><path d="M86.407 2.698s1.976-.998 3.868.3c1.893 1.3 1.72 3.534 1.72 3.534L90.328 8.87 84.74 5.034l1.666-2.336Z" fill="#fff"/></mask><g mask="url(#a)"><path d="M85.724 3.608s1.977-.998 3.87.3c1.892 1.3 1.718 3.534 1.718 3.534L89.647 9.78l-5.588-3.835 1.665-2.336Z" fill="#B3B3B3"/><path d="M90.18 1.246s1.673-.073 3.077.891c1.405.964-.364 6.15-.364 6.15L76.481 32.201l-3.912-.55-2.83-1.187L90.182 1.246Z" fill="#000" style="mix-blend-mode:overlay" opacity=".3"/><path d="M93.367 1.25s1.29 1.391 2.695 2.355c1.405.964 1.818 2.9 1.818 2.9L81.467 30.422l-3.912-.55-2.829-1.187L93.367 1.25Z" fill="#000" style="mix-blend-mode:overlay" opacity=".3"/></g><path d="M84.813 4.808s2.365-.03 3.77.934c1.404.964 1.817 2.9 1.817 2.9L73.987 32.559l-3.911-.55-1.676-3.284L84.813 4.808Z" fill="#FFB000"/><mask id="b" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="68" y="4" width="23" height="29"><path d="M84.813 4.808s2.365-.03 3.77.934c1.404.964 1.817 2.9 1.817 2.9L73.987 32.559l-3.911-.55-1.676-3.284L84.813 4.808Z" fill="#fff"/></mask><g mask="url(#b)"><path d="M84.813 4.808s2.365-.03 3.77.934c1.404.964 1.817 2.9 1.817 2.9L73.987 32.559l-3.911-.55-1.676-3.284L84.813 4.808Z" fill="url(#c)" fill-opacity=".2" style="mix-blend-mode:overlay"/><path d="M90.874 4.812s1.29 1.391 2.695 2.355c1.405.964 1.817 2.9 1.817 2.9L78.974 33.983l-3.912-.55-2.83-1.188L90.875 4.813Z" fill="#000" style="mix-blend-mode:overlay" opacity=".3"/><path d="M87.688 4.808s1.671-.073 3.076.89c1.405.965-.364 6.15-.364 6.15L73.987 35.764l-3.911-.55-2.83-1.188L87.689 4.808Z" fill="#000" style="mix-blend-mode:overlay" opacity=".3"/></g><path d="m66.89 36.534 7.167-3.957s-.648-1.984-1.764-1.389c-1.115.596-1.476-.146-1.649-1.114-.173-.968-2.193-1.405-2.193-1.405l-1.56 7.865Z" fill="#A6967A"/><path d="m66.89 36.534 7.167-3.957s-.648-1.984-1.764-1.389c-1.115.596-1.476-.146-1.649-1.114-.173-.968-2.193-1.405-2.193-1.405l-1.56 7.865Z" fill="url(#d)" style="mix-blend-mode:overlay"/><path d="m67.573 33.146-.683 3.412 3.072-1.706-2.39-1.706Z" fill="#121212"/><defs><radialGradient id="c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(25.36595 -36.17201 34.26425 24.02811 70.986 33.146)"><stop/><stop offset="1" stop-color="#fff" stop-opacity=".01"/></radialGradient><linearGradient id="d" x1="77.42" y1="30.31" x2="70.486" y2="28.296" gradientUnits="userSpaceOnUse"><stop/><stop offset="1" stop-opacity=".01"/></linearGradient></defs></svg>
			<strong>No upcoming jobs?</strong>
			<p style="max-width:340px;" class="text-center"><router-link :to="{ name: $routes.Profile.name, params: { 'edit': true } }">Update your profile</router-link> or <router-link :to="{ name: $routes.Availability.name  }">add availability</router-link> to be found by studios looking for help.</p>
		</div>
	</div>	
</template>

<script>
import { request } from '@/plugins/axios';
import Role from '@/models/Role';
import SyncCalendarButton from '@/components/calendars/SyncCalendarButton';

export default {
	name: 'CardUpcomingJobs',
	components: { SyncCalendarButton },
	data() {
		return {
			loading: true,
			items: [],
		};
	},
	methods: {
		fetchData() {
			request({
				url: '/jobs/me/upcoming?limit=3&includeChatInfo=true',
				method: 'get',
			}).then((response) => {
				this.items = response.data;
				this.cache = response.data;
				this.loading = false;
			});
		},
		getRoleName(roleId) {
			return (Role.from(roleId) || Role.missing).name;
		},
		toJob(job) {
			this.$router.push({ name: this.$routes.JobDetails.name, params: { jobId: job.id } });
		},
		toJobChat(job, e) {
			e.stopPropagation();
			this.$router.push({ name: 'thread', params: { jobId: job.id, chatId: job._chatInfo.chatId } });
		},
		toStudio(job, e) {
			e.stopPropagation();
			this.$router.push({ name: this.$routes.Profile.name, params: { id: job.creator.profile.id } });
		},
		toShooter(job, e) {
			e.stopPropagation();
			this.$router.push({ name: this.$routes.Profile.name, params: { id: job.contract.employee.profile.id } });
		},
	},
	computed: {
		cache: {
			get() {
				return this.$store.getters['cache/dashboardUpcomingJobs'];
			},
			set(items) {
				return this.$store.commit('cache/setCache', { name: 'dashboardUpcomingJobs', items });
			},
		}
	},
	created() {
		if ( this.cache ) {
			this.items = this.cache;
		}
		this.loading = !this.cache.length;
		this.fetchData();
	},
}
</script>
